import Vue from 'vue';

import { currency } from "@/filters/money";
Vue.filter('currency', currency)


Vue.filter('upper', () => import('@/filters/upper'))
Vue.filter('nl2br', () => import('@/filters/nl2br'))